import { ImageDtoType } from 'types/services/magnolia/dtos/ImageDto';
import { AssetsActionType } from './assets.actionCreators';
import { LOAD_ASSET_SUCCESS } from './assets.actionTypes';

export type AssetsStateType = {
	readonly container: {
		[key: string]: {
			[ratio: string]: ImageDtoType;
		};
	};
};

export type RootStateType = {
	assets: AssetsStateType;
};

export const initialState: AssetsStateType = {
	container: {},
};

export default (state: AssetsStateType = initialState, action: AssetsActionType) => {
	switch (action.type) {
		case LOAD_ASSET_SUCCESS:
			return {
				...state,
				container: {
					...state.container,
					[action.path]: {
						...(state.container[action.path] || {}),
						[action.ratio]: action.model,
					},
				},
			};
		default:
			return state;
	}
};
